import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import POTATOFLAKES from "../assests/img/ProductsImages/POTATOFLAKES.jpg";

export default function PotatoFlakes() {
  return (
    <div className="container py-4">
      {/* Title */}
      <div class="title-area mb-30 text-center">
          {/* <span class="sub-title" style={{ fontFamily:'helvetica' }}><span style={{color:"#F0B323"}}>Frozen French Fries manufacturer in India</span></span> */}
          <h2 class="" style={{ fontFamily:'helvetica',color:'#0f1138 !important'}}>
              POTATO FLAKES & MASH </h2>
      </div>
      {/* Table */}
      <div className="table-responsive mt-4">
        <table className="table table-bordered custom-table ">
          <thead>
            <tr>
              <th>APPLICATION</th>
              <th>TYPES OF FLAKES</th>
              <th>PACKAGING</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Snacks</td>
              <td>Flakes, Milled Flakes, Low Leach</td>
              <td rowSpan={8}>
                <ul>
                  <li>Bags of 5,10,15,20,25 kg</li>
                  <li>Big Bags</li>
                  <li>Tanker</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>Soups</td>
              <td>Milled Flakes</td>
              {/* <td>Bulk / Retail</td> */}
            </tr>
            <tr>
              <td>Ready Meals</td>
              <td>Flakes or Milled Flakes</td>
              {/* <td>Bulk / Retail</td> */}
            </tr>
            <tr>
              <td>Prepared Pasta</td>
              <td>Flakes or Milled Flakes</td>
              {/* <td>Bulk / Retail</td> */}
            </tr>            
            <tr>
              <td>Mixes</td>
              <td>Milled Flakes</td>
            </tr>
            <tr>
              <td>Repacks</td>
              <td>Flakes</td>
            </tr>
            <tr>
              <td>Bakery</td>
              <td>Flakes or Milled Flakes</td>
            </tr>
            <tr>
              <td>Pet Food</td>
              <td>Flakes or Milled Flakes</td>
            </tr>                                    

          </tbody>
        </table>
      </div>

      {/* Description */}
      <p className="mt-3 text-center ">
        <b><i>No peeling, no slicing, no mashing, no labor, no waste! <br />
        This ultimate comfort food is delivered completely prepared in
        convenient pouches. Just heat and embellish natural mashed potato
        goodness. Use them in potato patties, popular Indian dishes, soups,
        stews, or your own recipes.</i></b>
      </p>

      {/* Highlight Circles with Product */}
      <div className="d-none row text-center mt-4 align-items-center">
        {/* <div className="col-md-4 mb-3">
          <div className="highlight-circle mx-auto">
            GOOD FOR <br /> HEALTH
          </div>
        </div> */}
        <div className="col-6 col-md-4 col-xl-2 mb-3 product-center">
          <img
            src={POTATOFLAKES}
            alt="Potato Flakes"
          />
        </div>
        <div className="col-6 col-md-4 col-xl-2 mb-3 product-center">
          <img
            src={POTATOFLAKES}
            alt="Potato Flakes"
          />
        </div>

        <div className="col-6 col-md-4 col-xl-2 mb-3 product-center">
          <img
            src={POTATOFLAKES}
            alt="Potato Flakes"
          />
        </div>
        <div className="col-6 col-md-4 col-xl-2 mb-3 product-center">
          <img
            src={POTATOFLAKES}
            alt="Potato Flakes"
          />
        </div>
        <div className="col-6 col-md-4 col-xl-2 mb-3 product-center">
          <img
            src={POTATOFLAKES}
            alt="Potato Flakes"
          />
        </div>
        <div className="col-6 col-md-4 col-xl-2 mb-3 product-center">
          <img
            src={POTATOFLAKES}
            alt="Potato Flakes"
          />
        </div>                                                               
        {/* <div className="col-md-4 mb-3">
          <div className="highlight-circle mx-auto">
            FOOD <br /> READY IN MINUTES
          </div>
        </div> */}
      </div>

      {/* Scoped styles */}
      <style jsx>{`
        body {
          // background-color: #0f1138;
          color: #fff;
        }
        .section-title {
          // text-align: center;
          color: #0f1138;
          font-weight: bold;
          margin-top: 20px;
        }
        .custom-table {
          background-color: #fff;
          background-color: #0f1138;          
          color: #000;
          color: #fff;
          border-radius: 8px;
          overflow: hidden;
        }
        .custom-table th {
          background-color: #f4c542;
          color: #000;
        }
        .highlight-circle {
          background-color: #f4c542;
          color: #000;
          border-radius: 50%;
          width: 160px;
          height: 160px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          // font-size: 14px;
          padding: 15px;
          font-weight: bold;
        }
        .product-center img {
          max-width: 180px;
        }

        @media (max-width: 768px) {
          .highlight-circle {
            width: 120px;
            height: 120px;
            // font-size: 12px;
            margin: 10px auto;
          }
          .product-center img {
            max-width: 140px;
          }
        }
      `}</style>
    </div>
  );
}
